package ru.villawonka.app.domain.usecase

import ru.villawonka.app.common.utils.Either
import ru.villawonka.app.domain.model.NetworkFailure
import ru.villawonka.app.domain.model.PostTypeDomain
import ru.villawonka.app.domain.repository.PostsRepository

class DislikePostUseCase(private val postsRepository: PostsRepository) {

    suspend operator fun invoke(postId: Int, postType: PostTypeDomain): Either<NetworkFailure, Unit> =
        when (postType) {
            PostTypeDomain.ACCOMMODATION -> postsRepository.dislikeAccommodationPost(postId)
            else -> throw NotImplementedError()
        }
}